import { DynamicObjectInterface } from '../type';
import { AxiosUtilsType, axiosGet, axiosPost, axiosPut } from './axiosUtils';
import './axiosInterceptor';

const RedemptionService = {
  async getRedemptionList(campaignId: string): AxiosUtilsType {
    return await axiosGet(`redemption/campaign?id=${campaignId}`);
  },

  async claimRedemption(redemption: DynamicObjectInterface): AxiosUtilsType {
    return await axiosPost(`redemption/create`, redemption);
  },

  async getRedemptionByOrder(redemption: DynamicObjectInterface): AxiosUtilsType {
    return await axiosPost(`redemption/byOrder`, redemption);
  },

  async getRedemptionRewardByOrder(redemption: DynamicObjectInterface): AxiosUtilsType {
    return await axiosPost(`redemption/reward`, redemption);
  },

  // async getRedemptionDetails(selectedRowId: string): AxiosUtilsType {
  //   return await axiosGet(`redemption/list/${selectedRowId}`);
  // },

  async updateRedemption(redemption: DynamicObjectInterface): AxiosUtilsType {
    return await axiosPut(`redemption/updateStatus`, redemption);
  },

  async updateRedemptionByOrder(redemption: DynamicObjectInterface): AxiosUtilsType {
    return await axiosPut(`redemption/updateStatusByOrder`, redemption);
  },

  // async deleteRedemption(selectedRowId: string): AxiosUtilsType {
  //   return await axiosPatch(`redemption/list/${selectedRowId}`);
  // },
};
export default RedemptionService;
